;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	type EditOrganizationSchema,
	type EditOrganizationUserSchema,
	editOrganizationSchema,
	editOrganizationUserSchema,
	type RemoveOrganizationUserSchema,
	removeOrganizationUserSchema,
} from "@/lib/schema/organization";
import { logger } from "@/lib/services/logger";
import { queryFetcher } from "@/queries/config/query-fetcher";

/**
 * Query to edit an organization
 * @param {EditVisualizationSchema} data
 * @returns
 */
export function editOrganizationQuery(data: EditOrganizationSchema) {
	const validationResult = editOrganizationSchema.safeParse(data);

	if (!validationResult.success) {
		const errorMessage = "Error editing organization";

		logger.error(errorMessage, validationResult.error, { data });
		throw new Error(errorMessage);
	}

	return queryFetcher("/api/organizations", {
		body: JSON.stringify(validationResult.data),
		method: "PUT",
	});
}

export function removeOrganizationUser(
	data: RemoveOrganizationUserSchema & {
		userId: string;
	},
) {
	const { userId, ...body } = data;
	const validationResult = removeOrganizationUserSchema.safeParse(body);

	if (!validationResult.success) {
		const errorMessage = "Error removing organization member";

		logger.error(errorMessage, validationResult.error, { data });
		throw new Error(errorMessage);
	}

	return queryFetcher(`/api/organizations/users/${userId}/remove`, {
		body: JSON.stringify(validationResult.data),
		method: "POST",
	});
}

export function editOrganizationUser(
	data: EditOrganizationUserSchema & { userId: string },
) {
	const { userId, ...body } = data;
	const validationResult = editOrganizationUserSchema.safeParse(body);

	if (!validationResult.success) {
		const errorMessage = "Error updating organization member";

		logger.error(errorMessage, validationResult.error, { data });
		throw new Error(errorMessage);
	}

	return queryFetcher(`/api/organizations/users/${userId}`, {
		body: JSON.stringify(validationResult.data),
		method: "PUT",
	});
}

export type RequestPremiumUpgradeResponse = {
	cooldownUntil: string;
};

export function requestPremiumUpgradeQuery(): Promise<RequestPremiumUpgradeResponse> {
	return queryFetcher<RequestPremiumUpgradeResponse>(
		"/api/organizations/request-premium-upgrade",
		{
			method: "POST",
		},
	);
}
